export const TYPE_CHANGE_REF = 'TYPE_CHANGE_REF'
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB'
